import React, { useState } from 'react';
import { Tabs } from '../components/ui/Tabs';
import { DebtCollectionTable } from '../components/legal/DebtCollectionTable';
import { UnpaidInvoicesTable } from '../components/legal/UnpaidInvoicesTable';
import { SearchIcon } from 'lucide-react';
export function Legal() {
  const [searchTerm, setSearchTerm] = useState('');
  return <div className="space-y-6 pb-16" data-id="element-2179">
      <div data-id="element-2180">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2181">
          Recupero Crediti Legale
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2182">
          Gestione delle pratiche di recupero crediti tramite azione legale
        </p>
      </div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-2183">
        <div className="w-full md:w-1/3" data-id="element-2184">
          <div className="relative rounded-md shadow-sm" data-id="element-2185">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2186">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-2187" />
            </div>
            <input type="text" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Cerca cliente, fattura, piano..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2188" />
          </div>
        </div>
      </div>
      <Tabs tabs={[{
      id: 'debt-collection',
      name: 'Recupero Coatto',
      content: <DebtCollectionTable searchTerm={searchTerm} data-id="element-2190" />
    }, {
      id: 'unpaid-invoices',
      name: 'Partite Scadute',
      content: <UnpaidInvoicesTable searchTerm={searchTerm} data-id="element-2191" />
    }]} data-id="element-2189" />
    </div>;
}